export const initializeSockets = (io) => (dispatch) => {
  dispatch({ type: 'INITIALIZE_WEB_SOCKETS', payload: io });
};
